import { make } from 'vuex-pathify'

const state = {
  siteName: 'Fernando G - UI/UX Software Engineer',
  logo: 'https://res.cloudinary.com/fsquaredmedia/image/upload/v1540799778/fernandog/logo-name.svg',
  poll_interval: null,
  interval_time: new Date(),
  mainMenu: [
    { label: 'Wordpress', icon: 'fab fa-wordpress-simple', url: '/somewhere' },
    { label: 'Google Analytics', icon: 'fal fa-analytics', url: '/somewhere' },
    { label: 'Google Tag Manager', icon: 'fal fa-tag', url: '/somewhere' },
    { label: 'Vue JS', icon: 'fab fa-vuejs', url: '/somewhere' },
    { label: 'Work Life', icon: 'fal fa-briefcase', url: '/somewhere' },
    { label: 'UI/UX', icon: 'fal fa-code', url: '/somewhere' },
    { label: 'Spotify Playlist', icon: 'fab fa-spotify', url: '/somewhere' },
    { label: 'Favorite Places', icon: 'fal fa-map-marked', url: '/somewhere' }
  ],
  socialMenu: [
    { label: 'LinkedIn', icon: 'fab fa-linkedin', url: 'https://www.linkedin.com/in/fernando-a-garcia-ui-ux' },
    { label: 'GitHub', icon: 'fab fa-github-square', url: 'https://github.com/fernandoagarcia' },
    { label: 'Codepen', icon: 'fab fa-codepen', url: 'https://codepen.io/fsquaredmedia' }
  ]
}
const getters = make.getters(state)

const actions = {
  ...make.actions(state),
  startPolling ({ commit, state }) {
    commit('SET_POLL_INTERVAL', setInterval(() => {
      commit('SET_INTERVAL_TIME', new Date())
    }, 5000))
  }
}

const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
